import { render, staticRenderFns } from "./ReportCardPage.vue?vue&type=template&id=748fec33&scoped=true&"
import script from "./ReportCardPage.vue?vue&type=script&lang=js&"
export * from "./ReportCardPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportCardPage.vue?vue&type=style&index=0&id=748fec33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fec33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VMain,VProgressLinear})
